const html = require("./html/AvailableQuotesListView.html");
import {setElementsFromScope, swapClasses, insertValAndManageFocus, show, hide, handleDisplayFor} from "../../../utilities/selectorHelpers";
import {unbindAll, extractElements} from "../../../utilities/viewHelpers";
import _ from "underscore";
import $ from "jquery";
import AvailableQuoteView from "./AvailableQuoteView";
import QuoteStore from "../../../stores/QuoteStore";

const elementsMap = {
  availableQuoteViewsEntryPoint: ".available-quote-views-entry-point"
}
 
export default function AvailableQuotesListView(_unused, {
  getAsn,
  onAsnFieldsChange,
  isPallet
}){
  const self = this;
  self._element = $();
  const els = {};
  let availableQuoteViews = [];

  self.init = function(){
    render();
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, self._element);
  }

  function setWidgets(){

  }

  self.getElement = function(){
    return self._element;
  }

  function update(){
    updateSelf();
    updateChildren();
  }

  function updateSelf(){
    // No self inputs
  }

  function updateChildren(){
    unbindAll(availableQuoteViews);
    availableQuoteViews = renderAvailableQuoteViews();
    els.availableQuoteViewsEntryPoint.html(extractElements(availableQuoteViews));
  }


  function bindStores(){
    // NOTE: we don't need to bind to anything asn related
    // because the parent view should handle hiding this one
    // if anything asn related changes
    QuoteStore.bindListener("quotes:change", updateChildren);
    QuoteStore.bindListener("quotes:remove", updateChildren);
  }

  self.unbindListeners = function(){
    QuoteStore.unbindListener("quotes:change", updateChildren);
    QuoteStore.unbindListener("quotes:remove", updateChildren);
  }


  function render(){
    self._element = $(html);
    setElements();
    setWidgets();
    update();
    bindStores();
  }

  function getAvailableQuotes(){
    return AsnStore.getAvailableAndSelectedQuotesForAsn(getAsn());
  }

  function getSelectedQuote(){
    return AsnStore.getSelectedQuoteForAsn(getAsn());
  }


  function renderAvailableQuoteViews(){
    return _(getAvailableQuotes()).map((availableQuote, rowIdx)=>{
      const id = QuoteStore.idAttribute(availableQuote);
      const availableQuoteView = new AvailableQuoteView(id, {
        getSelectedQuote,
        onAsnFieldsChange,
        getAsn
      });
      availableQuoteView.init();
      return availableQuoteView;
    });
  }

}


// WEBPACK FOOTER //
// ./src/pages/asns/ShippingTab/AvailableQuotesListView.js